import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ViewLocaleWrapper = styled.div`
  padding-left: 16px;
  ${responsive.MOBILE`
      padding-right: 16px;
  `}

  .MuiGrid2-container {
    padding-right: 0px;
  }
`;
